import TemplateStudio from './TemplateStudio';

export default TemplateStudio;
